import React from 'react'
import { useBenefits } from '../BenefitsProvider'
import { Button } from '~/lib/ui/button'
import { useTranslation } from '~/hooks/useTranslation'
import ScheduleDialog from '../ProfessionalServices/ScheduleDialog'
import MeetingInfo from '../ProfessionalServices/MeetingInfo'
import { RevisionFeedback } from './Step'
import CloseReviewDialog from './CloseReviewDialog'

const ResumeRevisions = () => {
  const {
    resumeRevisions,
    resumeReview,
    onScheduleClick,
    current_user,
    coach,
    setShowCloseReviewDialog,
  } = useBenefits()
  const { t } = useTranslation()

  const calendlyEventExists =
    resumeRevisions[resumeRevisions?.length - 1].calendly_event != undefined

  const meetingViaCalendly =
    resumeRevisions[resumeRevisions?.length - 1].meeting_via_calendly

  const revisionScheduled =
    resumeReview.status === 'revision_meeting_requested' && calendlyEventExists

  const revisionReturned =
    resumeReview.status === 'revision_returned' ||
    resumeReview.status === 'final_revision_returned' ||
    (resumeReview.status === 'closed' && resumeRevisions.length > 2)

  const scheduleRevisionMeeting =
    (resumeReview.status !== 'closed' &&
      (resumeReview.status === 'returned' ||
        (resumeReview.status == 'revision_meeting_requested' &&
          meetingViaCalendly &&
          !calendlyEventExists))) ||
    (resumeReview.status === 'revision_requested' &&
      meetingViaCalendly &&
      !calendlyEventExists)

  const coachRevisionCount = resumeRevisions.filter(
    (revision) => revision.type === 'ResumeRevision::CoachRevision',
  ).length

  const handleSubmitRevisionRequest = () => {
    onScheduleClick(
      'ResumeRevision::CandidateRevision',
      t('steps.askForRevisions.submit_revision_request'),
      false,
      1,
      coachRevisionCount,
    )
  }

  if (!resumeReview || !resumeRevisions) return null
  return (
    <>
      {revisionReturned && <RevisionFeedback revision={resumeRevisions[2]} />}
      {revisionScheduled && (
        <div className="mt-4">
          <MeetingInfo
            calendlyEvent={
              resumeRevisions[resumeRevisions?.length - 1].calendly_event
            }
            requestType="ServiceRequest::ResumeReview"
            buttonText="Schedule a Meeting"
            requestComplete={resumeReview.status == 'returned'}
            eventName="Meeting"
            cardTitle="Schedule Your Coach Meeting"
            flexResumeReview={true}
            meetingViaCalendly={true}
          />
        </div>
      )}
      {scheduleRevisionMeeting && (
        <div className="mt-4 space-y-6">
          <div className="flex gap-4">
            <Button variant="coachcta" onClick={handleSubmitRevisionRequest}>
              {t('steps.askForRevisions.submit_revision_request')}
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                setShowCloseReviewDialog(true)
              }}
            >
              {t('close_review')}
            </Button>
            <ScheduleDialog
              current_user={current_user}
              coach={coach}
              flexResumeReview={true}
            />
            <CloseReviewDialog />
          </div>
        </div>
      )}
    </>
  )
}

export default ResumeRevisions
